import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { ProductTreeFamilyNode } from "../../definitions/product-tree";
import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class V2ProductTreeService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		super("mpapi/v2", appConfigService.getConfigValue("API_ENDPOINT") as string);
	}

	getProductTree(): Observable<ProductTreeFamilyNode[]> {
		return this.api.getAndThrowError<ProductTreeFamilyNode[]>(this.url("/product-tree"));
	}
}
